<template>
    <div class="col-md-4">
      <h6 data-v-5944f9f8="" class="text-center" v-if="title">{{title}}</h6>
      <div class="position-relative">
        <div class="bg-javis-light p-3 py-1 px-1 d-flex justify-content-between" style="border-top-left-radius: 8px; border-top-right-radius: 8px">
          <div class="w-50 "></div>
          <div class="w-50 text-center py-2" style="background: #b4d5a6; border-radius: 8px;"><b>Supir</b></div>
        </div>
        <hot-table
          :settings="settings"
          :contextMenu="contextMenu"
          :afterInit="afterInit"
          :afterUpdateData="afterUpdateData"
          :afterChange="afterChange"
          :data="initialData"
          :mergeCells="initialMergeCells"
          :afterMergeCells="afterMergeCells"
          :colHeaders="false"
          height="auto"
          width="auto"
          className="table-map"
          ref="map"
        ></hot-table>
        <div class="d-flex justify-content-center gap-2" v-if="!disabled">
          <div class="buttonMapAction" @click="removeRow" role="button" v-if="(countRows > 1)">
            <i class="fa fa-minus"></i>
          </div>
          <div class="buttonMapAction" @click="addRow" role="button">
            <i class="fa fa-plus"></i>
          </div>
        </div>
        <div class="d-flex flex-column justify-content-center gap-2 position-absolute" style="top:50%; right: -18px; z-index: 10;" v-if="!disabled">
          <div class="buttonMapAction" @click="addCol" role="button">
            <i class="fa fa-plus"></i>
          </div>
          <div class="buttonMapAction" @click="removeCol" role="button" v-if="(countCols > 1)">
            <i class="fa fa-minus"></i>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import { HotTable } from "@handsontable/vue";

export default {
  components: {
    HotTable,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    mapData: {
      type: Array,
      default: () => [[null, null]],
    },
    mergeCells: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      settings: {
        licenseKey: "non-commercial-and-evaluation",
        mergeCells: true,
        stretchH: "all",
        // colHeaders: ["", "Supir"],
      },
      contextMenu: ['mergeCells'],
      init: true,
      tableData: {
        mapData: [],
        mergeCells: [],
      },
      initialData: [[null, null]],
      initialMergeCells: [],
      merge: [],
      countRows: 0,
      countCols: 0,
    };
  },
  mounted() {
    setTimeout(() => {
      this.addRow();
      this.removeRow();
    }, 1000);
  },
  // computed: {
  // },
  methods: {
    // countRows() {
    //   return this.$refs?.map?.hotInstance?.countRows() || 0;
    // },
    updateData(data = null, merge = null) {
      const mapData = data || this.$refs.map.hotInstance.getData();
      const mergeCells = merge || [...this.$refs.map.hotInstance.getPlugin('mergeCells').mergedCellsCollection.mergedCells];
      // if(this.init){
      //   return;
      // }
      // rerender
      this.$refs.map.hotInstance.render();
      this.$set(this, 'countRows', this.$refs.map?.hotInstance?.countRows() || 0);
      this.$set(this, 'countCols', this.$refs.map?.hotInstance?.countCols() || 0);
      this.$emit("mapUpdated", mapData, mergeCells);
    },
    afterInit(){
      this.$refs.map.hotInstance.updateData(this.mapData);
      this.$refs.map.hotInstance.updateSettings({ mergeCells: this.mergeCells });
      // this.validateMergedCells();
      this.addRow();
      this.removeRow();
      this.init = false;
    },
    afterUpdateData(){
      this.$refs.map.hotInstance.updateSettings({ mergeCells: this.mergeCells});
      this.updateData(null);
      // this.countRows();
    },
    afterChange() {
      this.updateData();
    },
    addRow() {
      this.$refs.map.hotInstance.updateSettings({ mergeCells: this.mergeCells});
      this.$refs.map.hotInstance.alter("insert_row_above", this.mapData.length);
      this.updateData();
    },
    removeRow() {
      this.$refs.map.hotInstance.updateSettings({ mergeCells: this.mergeCells});
      const length = this.$refs.map.hotInstance.countRows();
      this.$refs.map.hotInstance.alter("remove_row", length - 1);
      this.updateData(null, this.mergeCells);
    },
    addCol(){
      this.$refs.map.hotInstance.updateSettings({ mergeCells: this.mergeCells});
      // const length = this.$refs.map.hotInstance.countCols();
      this.$refs.map.hotInstance.alter("insert_col_end");
      this.updateData();
    },
    removeCol(){
      this.$refs.map.hotInstance.updateSettings({ mergeCells: this.mergeCells});
      this.$refs.map.hotInstance.alter("remove_col");
      this.updateData(null, this.mergeCells);
    },
    // eslint-disable-next-line no-unused-vars
    afterMergeCells(cellRange, mergeParent, auto) {
      // eslint-disable-next-line no-unused-vars
      const mergeCells = this.$refs.map.hotInstance.getPlugin('mergeCells').mergedCellsCollection.mergedCells;
      this.updateData();
    },
    validateMergedCells(){
      const mergeCells = this.$refs.map.hotInstance.getPlugin('mergeCells').mergedCellsCollection.mergedCells;
      const data = this.$refs.map.hotInstance.getData();
      const length = data.length;
      const lastRow = data[length - 1];
      const lastRowIsEmpty = lastRow.every((item) => item === null);
      if (lastRowIsEmpty) {
        this.$refs.map.hotInstance.alter("remove_row", length - 1);
      }
      if (mergeCells.length === 0) {
        this.addRow();
      }
      this.updateData(null, mergeCells);
    }
  },
};
</script>

<style scoped>
  .table-map {
    border-right: 1px solid #E5E5E5 !important;
  }
</style>
